import useChangeLocation from "./useChangeLocation";

export default useChangeLocation;
